<template>
  <div class="synchronize-article">
    <div class="mention">
      <div class="text">
        <i class="el-icon-info"></i>
        公众号文章同步：开启后，会将公众号最新发布的文章自动同步到 【素材库】-【原创文章】中；
      </div>
      <div class="more-info">
        <mk-popover
          placement="bottom-end"
          title=""
          width="240"
          trigger="hover"
          content=""
          popover-class="more-info-popover"
        >
          <div
            slot="reference"
            class="more-description"
          >
            更多说明
          </div>
          <div
            class="tips-content"
          >
            关联公众号后，后台每隔一个小时，自动抓取对应公众号发布的文章；
          </div>
        </mk-popover>
      </div>
    </div>
    <div class="setting-button">
      <mk-button-biz
        width="108px"
        type="primary"
        @click="handleOpenSettingDialog"
      >
        文章同步设置
      </mk-button-biz>
    </div>
    <div class="table">
      <mk-table
        ref="table"
        :data="tableData"
        stripe
        style="width: 100%;"
      >
        <mk-table-column
          prop="name"
          label="公众号名称"
        >
        </mk-table-column>
        <mk-table-column
          prop="subject"
          label="主体信息"
        >
        </mk-table-column>
        <mk-table-column
          prop="subject"
          label="是否开启文章同步"
        >
          <template v-slot="scope">
            <mk-switch
              :value="scope.row.isSync === 1 ? true : false"
              active-color="#009CFF"
              inactive-color="#BFBFBF"
              @click.native="handleChangeSyncStaus(scope.row.isSync)"
            >
            </mk-switch>
          </template>
        </mk-table-column>
        <mk-table-column
          label="操作"
        >
          <template>
            -
          </template>
        </mk-table-column>
      </mk-table>
    </div>
    <setting-dialog
      :visible.sync="settingDialogVisible"
      :setting-info="settingInfo"
      @on-setting-change="handleOnSettingChange"
    />
  </div>
</template>

<script>
import SettingDialog from './setting-dialog'
export default {
  name: 'SynchronizeArticle',
  components: {
    SettingDialog
  },
  props: {
    // 公众号信息
    info: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      tableData: [{
        // 公众号名称
        name: '',
        // 主体信息
        subject: '',
        // 是否开启同步 1开启 2关闭
        isSync: false
      }],
      // 文章同步设置dialog
      settingDialogVisible: false,
      settingInfo: {},
      // 是否正在加载
      isLoading: false
    }
  },
  created () {
    this.articleSyncJobDetailGet()
  },
  methods: {
    // 获取微信同步文章设置
    async articleSyncJobDetailGet () {
      const { success, data } = await WXMPSVCAPIS.ArticleSyncJobApi.articleSyncJobDetailGet()
      const { nickName, principalName } = this.info
      if (success) {
        this.settingInfo = this._.cloneDeep(data)
        this.tableData = [{
          name: nickName,
          subject: principalName,
          isSync: data.isSync
        }]
      }
    },
    // 修改文章是否同步
    async articleSyncJobIsSyncPost (params) {
      const { success, data } = await WXMPSVCAPIS.ArticleSyncJobApi.articleSyncJobIsSyncPost(params)
      this.isLoading = false
      if (success) {
        this.$message.success('设置成功')
        this.articleSyncJobDetailGet()
      } else {
        this.$message.error('设置失败')
      }
    },
    // 打开设置弹窗
    handleOpenSettingDialog () {
      this.settingDialogVisible = true
    },
    // 修改是否同步
    handleChangeSyncStaus (isSync) {
      if (this.isLoading) { return }
      this.isLoading = true
      isSync = isSync === 2 ? 1 : 2
      let params = {
        isSync
      }
      this.articleSyncJobIsSyncPost(params)
    },
    // 处理设置改变
    handleOnSettingChange () {
      this.articleSyncJobDetailGet()
    }
  }
}
</script>

<style lang="scss" scoped>
.synchronize-article {
  .mention {
    margin: 16px 20px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 36px;
    background-color: #f2fbff;
    border: 1px solid #ccecff;
    border-radius: 4px;
    padding: 0 8px;
    font-size: 13px;
    color: #262626;

    .el-icon-info {
      color: #1b9aee;
      font-size: 16px;
      margin-right: 8px;
    }
  }

  .setting-button {
    margin: 16px 20px 0 20px;
    display: flex;
    justify-content: flex-end;
  }

  .table {
    margin: 16px 20px 0;

    /deep/ .el-table .has-gutter th {
      height: 39px !important;
      line-height: 39px !important;
      padding: 0;
    }

    /deep/ .el-table table tr {
      height: 40px !important;
      line-height: 40px !important;
    }
  }
}

.more-description {
  color: #209aff;
  cursor: pointer;
}

.tips-content {
  color: #595959;
  font-size: 12px;
  line-height: 16px;
}
</style>
